import React from 'react';
import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import classNames from 'classnames';

import messages from './messages';

const LargeLayout = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="caerus-brand-container d-flex flex-column justify-content-center h-100">

        <div className="d-flex flex-row align-items-center ml-5">
            
            {/* LOGO: Usamos <a> nativo en lugar de Hyperlink para evitar que desaparezca */}
            <a href={getConfig().MARKETING_SITE_BASE_URL || '/'}>
                <img 
                    src="https://lxp.caerus.space/static/indigo/images/logo.c6be52f48686.png" 
                    alt="Logo Caerus"
                    style={{ height: '140px', width: 'auto', display: 'block' }}
                    className="mr-4"
                />
            </a>

            {/* TEXTOS */}
            <div className="d-flex flex-column justify-content-center">
                <h1 className="main-heading mb-0" style={{ lineHeight: '1.2' }}>
                    {formatMessage(messages['start.learning'])}
                    <br />
                    <span className="text-accent-a">
                        {formatMessage(messages['with.site.name'], { siteName: getConfig().SITE_NAME })}
                    </span>
                </h1>
                
                {/* CRÉDITOS */}
                <div className="powered-by-container d-flex align-items-center mt-2">
                    <p className="powered-by-cincinnatus mb-0 mr-1">
                        Desarrollado por:
                    </p>
                    <a href="https://cincinnatus.edu.do/" target="_blank" rel="noopener noreferrer">
                        Cincinnatus
                    </a>
                </div>
            </div>

        </div>
    </div>
  );
};

export default LargeLayout;
